/*
 * *****************************************************************************
 *     Copyright (C)  Motorola Solutions, INC.
 *     All Rights Reserved.
 *     Motorola Solutions Confidential Restricted.
 * *****************************************************************************
 */

import { Injectable } from '@angular/core';
import { QueueMetricObj } from '../queue-metrics/+state/metrics.model';
import { Store } from '@ngrx/store';
import { updateMetrics } from '../queue-metrics/+state/metrics.actions';
import { StompBaseConsumer } from '../../core/abstract/stomp-base-consumer';
import { StompManagerService } from '../../core/services/stomp-manager/stomp-manager.service';
import { Topic } from '../../user/model/multiple-subscriptions';

@Injectable({ providedIn: 'root' })
export class MetricsService extends StompBaseConsumer {

    constructor(
        protected store: Store,
        protected stompManager: StompManagerService
    ) {
        super(stompManager, store);
    }

    protected getTopics(): Topic[] {
        return [Topic.CTC_QUEUE_METRICS_DATA];
    }

    protected getTopicHandlers(): { [topic in Topic]?: (message: any) => void } {
        {
            return {
                [Topic.CTC_QUEUE_METRICS_DATA]: this.handleQueueMetricsData.bind(this)
            };
        }
    }

    private handleQueueMetricsData(parsedMessage: QueueMetricObj[]): void {
        const metrics = parsedMessage.map((m) => ({ ...m, uuid: `${m.agencyId}_${m.queueId}` }));
        this.store.dispatch(updateMetrics({ metrics }));
    }

    handleSubscriptionInit(topic: string, receiptId: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Metrics topic ${topic} subscription success: ${receiptId}`);
    }

    handleSubscriptionEnd(topic: string, receiptId: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Metrics ${topic} subscription end: ${receiptId}`);
    }

    handleStompError(topic: string, receiptId: string, error: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Metrics ${topic} subscription failed=${error} for receiptId=${receiptId}`);
    }

}
